import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { distinctUntilChanged } from 'rxjs';

import { PuSubscribable } from '@app/utils/pu-subscribe';
import { IRadioButtonOption } from '@shared/interfaces/radio-button-option.interface';

export enum MobileUIMode {
  Standard,
  UserPreference,
  Stack,
}

@Component({
  selector: 'app-mobile-ui-menu',
  templateUrl: './mobile-ui-menu.component.html',
  styleUrls: ['./mobile-ui-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileUiMenuComponent extends PuSubscribable implements OnInit {
  @Input() set mobileMode(_mobileMode: MobileUIMode) {
    if (_mobileMode === this.form?.get('mobileMode')?.value) {
      return;
    }
    this.form.get('mobileMode')?.setValue(_mobileMode);
  }
  @Output() submitForm = new EventEmitter<MobileUIMode>();

  form: FormGroup = new FormGroup({
    mobileMode: new FormControl(),
  });
  readonly options: IRadioButtonOption<MobileUIMode>[] = [
    {
      value: MobileUIMode.Standard,
      label: 'Standard',
    },
    {
      value: MobileUIMode.UserPreference,
      label: 'User Preference',
    },
    {
      value: MobileUIMode.Stack,
      label: 'Stack',
    },
  ];

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.form
      .get('mobileMode')
      ?.valueChanges.pipe(distinctUntilChanged())
      .subscribe(value => this.submitForm.emit(value))
      .untilDestroyed(this);
  }
}
